import React, { FC, useEffect, useState } from "react";
import { ReactComponent as AddItemIcon } from "../../../assets/icons/add.svg";
import { useHistory, useLocation } from "react-router-dom";
import Modal from "../../../components/Modals/Modal";
import Input from "../../../components/DataEntry/Input";
import Select from "../../../components/DataEntry/Select";
import {
  useDeviceGroups,
  useDevices,
  useProgram,
  usePrograms,
} from "../../../Api/newSockets.api";
import AddButton from "../../../components/Buttons/AddButton";
import Table from "../../../components/Table/Table";
import Header from "../../../components/Header/Header";
import TextArea from "../../../components/DataEntry/TextArea";
import Tabs from "../../../components/Tabs/Tabs";
import develop_tab_data from "../../../assets/mockedData/develop_tab_data";
import { toast, ToastContainer } from "react-toastify";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import OutlinedButton from "../../../components/Buttons/OutlinedButton";
import validator from "validator";
import { savePathToLocalStorage } from "../../../utils/helpers";
// import Actions from "../Action/Actions";
// import Develop from "../Develop";

type Props = {};

const Programs: FC<Props> = () => {
  const headers = [
    {
      label: "Name",
      key: "name",
      type: "text",
    },
    {
      label: "Description",
      key: "description",
      type: "text",
    },
    {
      label: "Date Created",
      key: "dateCreated",
      type: "date",
    },
    {
      label: "Date Modified",
      key: "dateModified",
      type: "date",
    },
  ];

  savePathToLocalStorage();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [deviceGroupId, setDeviceGroupId] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [validationErrors, setValidationErrors] = useState({
    name: "",
    deviceId: "",
  });
  console.log("device group id", deviceGroupId);

  const { programs, searchPrograms, connected } = usePrograms();
  const { addProgram, deleteProgram } = useProgram();
  const { getDeviceByDeviceType } = useDevices();
  const { deviceGroups } = useDeviceGroups();
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [developTabData, setDevelopTabData] = useState(develop_tab_data);
  const [jetsonDevices, setJetsonDevices] = useState([]);
  const history = useHistory();
  const [row, setRow] = useState({ name: "" });
  const [errorModal, setErrorModal] = useState(false);

  useEffect(() => {
    if (!connected) return;
    getDeviceByDeviceType(7)
      .then((data: any) => setJetsonDevices(data ?? []))
      .catch(() => setJetsonDevices([]));
  }, [connected]);

  const handleNewProgram = () => {
    setModalOpen(true);
    console.log({ modalOpen });
  };
  const handleSubmitProgram = (program: any) => {
    if (validateFields()) {
      setLoading(true);
      console.log("submit program", program);
      addProgram({
        name: name,
        deviceGroupId: parseInt(deviceGroupId),
        data: {
          nodes: [
            {
              id: "0",
              type: "startNode",
              data: {
                block: {
                  name: "Start",
                  id: "0",
                  inputs: [],
                  outputs: [],
                  deviceTypeId: null,
                  deviceTypes: [],
                  deviceId: null,
                  runtime: 0,
                  type: "startNode",
                },
              },
              position: { x: 50, y: 50 },
              style: { borderColor: "#931538" },
            },
            {
              id: "1",
              type: "endNode",
              data: {
                block: {
                  name: "End",
                  id: "0",
                  inputs: [],
                  outputs: [],
                  deviceTypeId: null,
                  deviceTypes: [],
                  deviceId: null,
                  runtime: 0,
                  type: "endNode",
                },
              },
              position: { x: 100, y: 300 },
              style: { borderColor: "#931538" },
            },
          ],
          edges: [],
        },
        dateCreated: new Date(),
        dateModified: new Date(),
      }).then((data: any) => {
        console.log("newProg", data);
        history.push(`/develop/program/${data.id}`);
      });
    }
  };

  const handleDeleteProgram = (row) => {
    setLoading(true);
    deleteProgram(row.id)
      .then((data: any) => {
        console.log(data);
      })
      .then(() => setErrorModal(false))
      .then(() => setLoading(false))
      .catch((error: any) => {
        setErrorModal(false);
        setLoading(false);
        toasti(error);
        console.log(error);
      });
  };

  const openDeleteModal = (program: any) => {
    console.log(program);
    setRow(program);
    setErrorModal(true);
  };

  const onClose = (info) => {
    if (info == "error") {
      setErrorModal(false);
    } else if (info == "add") {
      setModalOpen(false);
    }
  };

  const filterPrograms = (searchValue) => {
    setSearchInput(searchValue);
  };

  useEffect(() => {
    searchPrograms(searchInput);
  }, [searchInput]);

  useEffect(() => {
    searchPrograms(searchInput);
  }, [connected]);

  const validateFields = () => {
    var formValidated = true;
    var newValidationErrors = { name: "", deviceId: "" };

    if (validator.isEmpty(name)) {
      newValidationErrors = { ...newValidationErrors, name: "Invalid name" };
      formValidated = false;
    }
    if (!validator.isInt(deviceGroupId)) {
      newValidationErrors = {
        ...newValidationErrors,
        deviceId: "Invalid device group",
      };
      formValidated = false;
    }
    setValidationErrors(newValidationErrors);
    return formValidated;
  };

  // Delete modal footer

  var footer = (
    <>
      <PrimaryButton
        className="delete-button-background-color"
        onSubmit={() => handleDeleteProgram(row)}
        loading={loading}
      >
        Delete
      </PrimaryButton>
      <OutlinedButton onClick={() => onClose("error")}>Cancel</OutlinedButton>
    </>
  );

  // Toastify to display error on screen
  const ErrorMessage = ({ error }) => <div>{error}</div>;
  const toasti = (error) => {
    toast.error(<ErrorMessage error={error} />, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <div>
      <div style={{ width: "100%" }}>
        <Header
          title="Programs"
          searchFunction={filterPrograms}
          mainAction={
            <AddButton
              icon={<AddItemIcon />}
              label="New program"
              onClick={handleNewProgram}
            />
          }
        />
        <div className="main-content-flex">
          <Tabs data={developTabData} />
          <div className="section">
            <Table
              items={programs}
              headers={headers}
              to="develop/program"
              tableName="programs"
              onDelete={openDeleteModal}
            />
          </div>
        </div>

        {/* User input modal */}
        <Modal
          visible={modalOpen}
          submitLoading={loading}
          title="Add new program"
          onSubmit={handleSubmitProgram}
          onClose={() => onClose("add")}
        >
          <Input
            placeholder="Enter a name"
            onChange={(e: any) => setName(e.target.value)}
            status={validationErrors.name && "error"}
            className="input-classic"
            validationMessage={validationErrors.name}
            onPressEnter={handleSubmitProgram}
          />
          <Select
            placeholder="Select group"
            options={deviceGroups}
            onChange={(e: any) => setDeviceGroupId(e.target.value)}
            className="select-classic"
            status={validationErrors.deviceId && "error"}
            validationMessage={validationErrors.deviceId}
            onPressEnter={handleSubmitProgram}
          />
          <TextArea
            onChange={(e: any) => setDescription(e.target.value)}
            placeholder="Add a description"
            className="textarea-classic"
            onPressEnter={handleSubmitProgram}
          />
        </Modal>
        {/* Delete modal */}
        <Modal
          title={`Delete ${row && row.name}`}
          subtitle={"Warning: this can't be undone"}
          desc="By deleting this program you will lose all data related to the program"
          visible={errorModal}
          footer={footer}
          onClose={() => onClose("error")}
        />
        <ToastContainer
          autoClose={5000}
          position="bottom-right"
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    </div>
  );
};

export default Programs;
